:host {
  display: block;
  width: 100%;
  box-sizing: border-box;
}
